import AuthContext from '@/context/AuthContext'
import React, { useContext } from 'react'
import Forbidden from '../Forbidden'

const AuthRequired: React.FC<PropType> = ({ message, onBack, children }) => {
  const { status } = useContext(AuthContext)

  if (status !== 'authorized') {
    return <Forbidden message={message} onBack={onBack} />
  }

  const Comp = children
  return <>{React.isValidElement(children) ? children : <Comp />}</>
}

interface PropType {
  message?: string
  onBack?: () => void
  children: any
}

export default AuthRequired
